import React from 'react';
import TagBadge from './TagBadge';

interface CatalogCardProps {
  name: string;
  description: string;
  tags: string[];
  style?: React.CSSProperties;
}

export default function CatalogCard({ name, description, tags, style }: CatalogCardProps) {
  return (
    <div
      className="bg-white rounded-md border border-black/[0.06] p-5 md:p-6 shadow-sm
                 hover:-translate-y-1 hover:shadow-md transition-all duration-300 flex flex-col"
      style={style}
    >
      <div className="flex flex-wrap gap-1.5 mb-4">
        {tags.map(tag => <TagBadge key={tag} label={tag} />)}
      </div>
      <h3 className="font-syne font-bold text-navy text-base mb-2">{name}</h3>
      <p className="text-text-mid text-sm leading-relaxed flex-1">{description}</p>
    </div>
  );
}
